import { render, staticRenderFns } from "./FormLabel.vue?vue&type=template&id=ca1e9754&"
import script from "./FormLabel.vue?vue&type=script&lang=js&"
export * from "./FormLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca1e9754')) {
      api.createRecord('ca1e9754', component.options)
    } else {
      api.reload('ca1e9754', component.options)
    }
    module.hot.accept("./FormLabel.vue?vue&type=template&id=ca1e9754&", function () {
      api.rerender('ca1e9754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/FormLabel.vue"
export default component.exports